import {Button, ButtonStyle} from '@mintdata-wsp/common/components/button/Button';
import {MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {
    DialogFrame,
    DialogKind,
    DialogSize
} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/baseDialog/BaseDialog';
import {Window} from '@mintdata/mint-kit/impl/components/popover/Window';
import {bind} from 'bind-decorator';
import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/tabsPanel/duplicateNameTabSheetDialog/ErrorTabSheetDialog.less');

export type CloseHandler = () => void;
export type ClickSuccessHandler = () => void;

export interface IDuplicateNameTabSheetDialogProps
{
    message:string,
    onClose?:CloseHandler,
    onClickSuccess?:ClickSuccessHandler
}

export class ErrorTabSheetDialog extends React.Component <IDuplicateNameTabSheetDialogProps, any>
{
    @bind
    private _onClose():void
    {
        const {
            onClose = () =>
            {
            }
        } = this.props;
        onClose();
    }

    @bind
    private _onClickSuccess():void
    {
        const {
            onClickSuccess = () =>
            {
            }
        } = this.props;
        onClickSuccess();
    }

    render():JSX.Element
    {
        const {message} = this.props;
        return (
            <Window id='duplicateNameTabSheetDialog' onDismissed={this._onClose}>
                <DialogFrame size={DialogSize.Dynamic} kind={DialogKind.Alert}>
                    <div className={styles.base}>
                        <Button
                            onClick={this._onClose}
                            className={styles.closeButton}
                            icon={MDIcons.common.Close}
                            iconSize={MDIconSize.medium}
                            style={ButtonStyle.SimpleSecondary}
                        />
                        <div className={styles.title}>There was a problem</div>
                        <div
                            className={styles.message}>{message}</div>
                        <Button className={styles.successButton} onClick={this._onClickSuccess} caption="Ok" />
                    </div>
                </DialogFrame>
            </Window>
        );
    }
}
